import { Injectable } from '@angular/core';
import { PrinterInfo, PrinterMode, ReceiptTail } from './printers';

/**
 * Build-time stub for `@gonnaorder/capacitor-printer`.
 *
 * The plugin is only installed for the GoAdmin builds (see
 * `installAdminPlugins` in capacitor-build-utils.js), so the customer, kiosk
 * and template builds would fail to resolve the import. `angular-mobile.json`
 * swaps this file for `goPrinter-capacitor.service.ts` on the goadmin and
 * goadmindev configurations only.
 *
 * Do not delete: it is load-bearing for the build.
 *
 * Since every AutoPrint transport moved onto the plugin, this stub is the only
 * thing standing between a non-admin build and an unresolvable import — there
 * is no longer a second printing library for those builds to fall back to.
 */
export interface DiscoveredPrinter {
  name: string | null;
  /** MAC address for the Bluetooth modes; IPv4 address for WiFi/Ethernet. */
  address: string;
  paired: boolean;
  /** WiFi/Ethernet only: the port the printer was found listening on. */
  port?: number;
}

@Injectable({
  providedIn: 'root',
})
export class GoPrinterService {
  /** False here, so callers can hide printing options on builds without it. */
  isAvailable(): boolean {
    return false;
  }

  async isEnabled(): Promise<boolean> {
    return false;
  }

  async requestEnable(): Promise<boolean> {
    return false;
  }

  async listPaired(): Promise<DiscoveredPrinter[]> {
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async scan(mode: PrinterMode): Promise<DiscoveredPrinter[]> {
    return [];
  }

  /**
   * Signatures must stay identical to `goPrinter-capacitor.service.ts`. The two
   * files are swapped at build time, so a mismatch only shows up as a
   * compile error in whichever configuration is not being built locally.
   */
  async print(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    printer: PrinterInfo,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    printData: Uint8Array,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tail: ReceiptTail,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    continuesReceipt: boolean,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    jobRef: string,
  ): Promise<boolean> {
    return false;
  }
}
